import api from '@/apis/di/bankInfoAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid CTMT
export const useBankViewComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBankViewComboboxLoadData = (payload, row, column) => {
    payload.sort = 'bank_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const bankViewComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã ngân hàng',
        dataField: 'bank_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên ngân hàng',
        dataField: 'bank_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'bank_code',
    valueField: 'bank_code',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBankViewComboboxLoadData,
  };

  return {
    bankViewComboConfig,
    onBankViewComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
